// Copyright (C) 2013 Minted Inc.
// All Rights Reserved

// Explicitly name global variables for "use strict".
(function(M, _, $, Backbone) {
  "use strict";

  M.View = M.View || {};
  M.View.ProductDetails = M.View.ProductDetails || {};

  /**
   * Renders a dialog that allows the user to select triple thick paper.
   */
  M.View.ProductDetails.InvalidCombinationDialog = Backbone.View.extend({

    template: _.template(M.Template.ProductDetails.InvalidCombinationDialog),

    events: {
      'click .switchButton': 'switchClicked',
      'click .keepButton': 'keepClicked'
    },

    initialize: function() {
      M.required(this.options.title);
      M.required(this.options.message);
      M.required(this.options.switchMessage);
      M.required(this.options.keepMessage);
      this.$el = $(this.el);
    },

    render: function() {
      var that = this;
      this.$el.html(this.template(this.options));

      this.$el.dialog({
        title: this.options.title,
        autoOpen: true,
        draggable: false,
        modal: true,
        width: 400
      });
      return this;
    },

    switchClicked: function(e) {
      this.$el.dialog('close');
      this.trigger('switchClicked');
    },

    keepClicked: function(e) {
      this.$el.dialog('close');
      this.trigger('keepClicked');
    }

  });

})(M, _, $, Backbone);
